export default "__VITE_ASSET__46d8d0f5__"